export const NavigationParamKeys = {
  DEVICE_ISSUE_TAB: 'device_issue_tab',
  HEALTH_MONITOR: 'health_monitor_tab',
} as const;

export const OsType = {
  MACOS: 'macos',
  WINDOWS: 'windows',
  ANDROID: 'android',
  IOS: 'ios',
} as const;

export type OsType = (typeof OsType)[keyof typeof OsType];
